module.exports = __webpack_public_path__ + "static/media/fire.3ae90b92.svg";